export function getBrowserLocale() {
  const browserLanguage = navigator.language;

  // Leaving locale validation to the backend.
  return browserLanguage;
}

export function getLanguageFromLocale(maybeLocaleOrLanguage: string) {
  const dashIndex = maybeLocaleOrLanguage.indexOf("-");
  if (dashIndex === -1) {
    return maybeLocaleOrLanguage;
  }

  return maybeLocaleOrLanguage.substring(0, dashIndex);
}
